/* unplugin-vue-components disabled */import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-70d63e46"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "text-color-orange",
  style: {
    "margin-left": "3px"
  }
};
const _hoisted_2 = {
  class: "input-wrap"
};
const _hoisted_3 = ["placeholder", "value"];
import { useI18n } from 'vue-i18n';
import moment from 'moment';
export default {
  __name: 'BaseCalendar',
  props: {
    modelValue: {
      type: [Array, String],
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    labelWidth: {
      type: String,
      default: 'auto'
    },
    maxLabelWidth: {
      type: String,
      default: 'auto'
    },
    placeholder: {
      type: String,
      default: ''
    },
    calendarParams: {
      type: Object,
      default: () => ({})
    },
    oneLine: {
      type: Boolean,
      default: false
    },
    search: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'onInputChange', 'send', 'change'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t,
      locale
    } = useI18n();
    const value = computed({
      get: () => props.modelValue,
      set: val => emit('update:modelValue', val)
    });
    watch(value, () => {
      emit('change');
    });
    watch(() => props.modelValue, val => {
      if (calendar) {
        if (props.calendarParams.rangePicker) return;
        if (!val) return;
        var val_str = val;
        let arr = val.split('/');
        if (arr.length == 2) {
          val_str += "/01";
        }
        calendar.setValue([moment(val_str).toDate()]);
      }
    });
    const inputElRef = ref(null);
    const newValue = ref('');
    const calendarParams = {
      header: true,
      footer: true,
      backdrop: true,
      cssClass: 'custom-calendar',
      dateFormat: `yyyy/mm/dd`,
      locale: locale.value == 'tw' ? 'zh-TW' : 'en',
      renderHeader: function () {
        return `
            <div class="header">
                <div class="title">
                    ${props.search ? t('searchDate') : t('selectDate')}
                </div>
                <a class="close-btn" href="javascript:;">
                    <i class="icon-close" sheet-close></i>
                </a>
            </div>
        `;
      },
      renderFooter: function () {
        return `
            <div class="footer">
                <a class="button button-outline color-theme w-full reset" style="margin-right:10px;">${t('reset')}</a>
                <a class="button button-fill color-theme w-full send ">${t('submit')}</a>
            </div>
        `;
      },
      on: {
        open(calendar) {
          if (!value.value) {
            calendar.setValue([moment().toDate()]);
          }
          if (calendar.params.timePicker) {
            calendar.$el[0].querySelector('.calendar-time-selector span').innerHTML = t('time');
          }
          $('.custom-calendar .close-btn').on('click', () => {
            calendar.close();
          });
          $('.custom-calendar .reset').on('click', () => {
            console.log('reset');
            calendar.setValue([]);
            value.value = '';
            emit('send');
          });
          $('.custom-calendar .send').on('click', () => {
            value.value = newValue.value;
            calendar.close();
            emit('send');
          });
        }
      }
    };
    const open = () => {
      emit('onInputChange');
      calendar.open();
    };
    var calendar;
    let dateFormat;
    onMounted(() => {
      const {
        on,
        ...rest
      } = {
        ...calendarParams,
        ...props.calendarParams
      } || {};
      switch (rest.dateFormat) {
        case 'yyyy/mm':
          dateFormat = 'YYYY/MM';
          break;
        case 'yyyy/mm/dd':
          dateFormat = 'YYYY/MM/DD';
          break;
        case 'yyyy/mm/dd':
          dateFormat = 'YYYY/MM/DD';
          break;
        case 'yyyy/mm/dd HH:mm':
          dateFormat = 'YYYY/MM/DD HH:mm';
          break;
        default:
          break;
      }
      var calendarValue;
      if (props.calendarParams.rangePicker) {
        calendarValue = [];
      } else {
        calendarValue = value.value ? [value.value] : null;
      }
      calendar = f7.calendar.create({
        inputEl: inputElRef.value,
        value: calendarValue,
        openIn: 'sheet',
        on: {
          ...on,
          monthYearChangeStart: rest.dateFormat === 'yyyy/mm' ? function (calendar) {
            calendar.setValue([moment(`${calendar.currentYear}/${calendar.currentMonth + 1}`, 'YYYY/MM').toDate()]);
          } : null,
          change(calendar, calendarValue) {
            // console.log('calendar',calendar);
            // console.log('calendarValue',calendarValue);
            // console.log('change',moment(props.modelValue).format(dateFormat || 'YYYY/MM/DD'));
            if (!calendarValue) return;
            // if(moment(calendarValue[0]).format(dateFormat || 'YYYY/MM/DD') == 'Invalid date') return;
            // emit('calendar:change', calendarValue);
            if (rest.rangePicker) {
              newValue.value = calendarValue.map(v => moment(v).format(dateFormat || 'YYYY/MM/DD'));
              return;
            }
            newValue.value = moment(calendarValue[0]).format(dateFormat || 'YYYY/MM/DD');
          }
        },
        ...(rest || {})
      });
      if (rest.dateFormat === 'yyyy/mm') {
        const arr = value.value.split('/');
        if (arr.length < 2) return;
        const currentYear = arr[0];
        const currentMonth = arr[1];
        calendar.setValue([moment(`${currentYear}/${currentMonth}`, 'YYYY/MM').toDate()]);
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["base-input", {
          'one-line': __props.oneLine
        }])
      }, [(_openBlock(), _createBlock(_resolveDynamicComponent(!!_ctx.info ? 'div' : 'label'), {
        class: "label-wrap"
      }, {
        default: _withCtx(() => [__props.label ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["label", {
            'text-color-blue': !!_ctx.info
          }]),
          onClick: _cache[0] || (_cache[0] = $event => !!_ctx.info ? _ctx.$emit('openInfo', _ctx.info) : null),
          style: _normalizeStyle({
            'width': __props.labelWidth,
            'max-width': __props.maxLabelWidth
          })
        }, [_createTextVNode(_toDisplayString(__props.label), 1), __props.required ? (_openBlock(), _createElementBlock("span", _hoisted_1, "*")) : _createCommentVNode("", true)], 6)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "start-icon"), _createElementVNode("input", {
          type: "text",
          onClick: open,
          placeholder: __props.placeholder,
          value: __props.modelValue,
          readonly: ""
        }, null, 8, _hoisted_3), _withDirectives(_createElementVNode("input", {
          ref_key: "inputElRef",
          ref: inputElRef,
          type: "hidden",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(value) ? value.value = $event : null),
          readonly: ""
        }, null, 512), [[_vModelText, _unref(value)]]), _renderSlot(_ctx.$slots, "icon")])]),
        _: 3
      }))], 2);
    };
  }
};